<template>
  <div style="color: #000" class="contents">
    <!--    <div class="home_tit">-->
    <!--      <div class="home_tit_top">-->
    <!--        <div class="home_tit_middle"></div>-->
    <!--        <div class="home_tit_right" @click="goTo(111)">-->
    <!--          <img src="../../assets/images/new/xiaoxibai.png" />-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div style="padding: 0 15px">
      <div style="" class="userBox">
        <div style="padding: 0px">
          <div class="user_con_top">
            <div class="header acea-row row-between-wrapper" style="">
              <div
                class="picTxt acea-row row-between-wrapper"
                style="display: flex; width: 100%"
              >
                <div
                  class="pictrue"
                  style="width: 50px; height: 50px"
                  @click="shezhi"
                >
                  <img
                    style="
                      width: 100%;
                      height: 100%;
                      border-radius: 50%;
                      object-fit: cover;
                    "
                    :src="userAvatar"
                  />
                </div>
                <div
                  class="text"
                  style="margin-left: 10px; width: auto; flex: 1"
                >
                  <div class="acea-row row-middle">
                    <div
                      style="font-weight: bold; font-size: 15px; color: #333;width: auto; margin-right: 5px;"
                      class="name line1"
                    >
                      {{ userNickname }}
                    </div>
                    <img
                      style="vertical-align: middle"
                      width="60px"
                      :src="vipList[userInfo.vip]"
                      alt=""
                    />
                  </div>
                  <div class="user-account-name">
                    用户名：{{ userAccountName }}
                  </div>
                  <div
                    style="margin-top: 6px;font-weight: bold; font-size: 15px; color: rgb(51, 51, 51); display:flex; justify-content:space-between; align-items:center;"
                  >
                    <span
                      style="
                        background: rgba(3, 114, 251, 0.08);
                        margin-right: 5px;
                        border-radius: 12px;
                        padding: 2px 8px;
                        color: var(--bg-color);
                        font-size: 12px;
                      "
                    >
                      {{ userVipName }}
                    </span>
                    <div
                      v-if="isAuthApproved"
                      style="
                        justify-content: center;
                        background: linear-gradient(
                          to bottom,
                          #fffbe6,
                          #ffe9a7,
                          #ffe9a7
                        );
                        color: #fd8535;
                        font-size: 11px;
                        border-radius: 20px;
                        display: flex;
                        align-items: center;
                        height: 25px;
                        float: right;
                        width: 80px;
                        font-weight: bold;
                      "
                    >
                      <img
                        style="width: 40px; height: 40px; margin-right: 3px"
                        src="@/assets/images/img/yuser.png"
                        alt=""
                        @click="wayToLink('/memmber_business')"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="balance-card">
          <div class="balance-copy">
            <p class="balance-label">{{ $t("m.yue") }}</p>
            <p class="balance-value">
              <span>{{ formatMoney(userInfo.money) }}</span>
              <em>USD</em>
            </p>
            <div class="balance-breakdown">
              <p><span>可购买金额</span><strong>{{ formatMoney(userInfo.buildable_money) }} USD</strong></p>
              <p><span>可提现金额</span><strong>{{ formatMoney(userInfo.withdrawable_money) }} USD</strong></p>
            </div>
          </div>
          <div class="balance-icon">
            <img src="../../assets/images/img/usdt.png" alt="" />
          </div>
        </div>

        <div class="account-hub">
          <div class="account-hub-title">
            <div>
              <small>ACCOUNT SERVICES</small>
              <h3>账户与资产服务</h3>
            </div>
            <button @click="wayToLink('/moneyDetail')">收支明细 ›</button>
          </div>
          <div class="account-service-grid">
            <button
              v-for="service in accountServices"
              :key="service.title"
              @click="wayToLink(service.path)"
            >
              <span :class="service.tone">{{ service.icon }}</span>
              <strong>{{ service.title }}</strong>
              <small>{{ service.desc }}</small>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div style="padding: 0 15px">
      <div class="user_con_mid" style="border-radius: 14px">
        <p class="user_con_mid_tit">{{ $t("m.xiangguan") }}</p>
        <div
          class="user_con_mid_block"
          style="display: flex; justify-content: space-around"
        >
          <div
            class="user_con_mid_line"
            v-for="(item, index) in moreList1"
            :key="index"
            @click="goTo(item.id)"
          >
            <img :src="item.icon" style="width: 30px" />
            <p class="">{{ $t("m.list3")[index] }}</p>
          </div>
        </div>
      </div>
      <div class="user_con_mid" style="border-radius: 14px">
        <!-- <p class="user_con_mid_tit">我的信息</p> -->
        <div class="user_con_mid_block">
          <div
            class="user_con_mid_line"
            v-for="(item, index) in conList"
            :key="item.id"
            @click="dianji(item.id)"
          >
            <img :src="item.img" />
            <p class="">{{ $t("m.list1")[index] }}</p>
          </div>
        </div>
      </div>
      <div class="user_con_mid" style="border-radius: 14px">
        <p class="user_con_mid_tit">其他功能</p>
        <div class="cell">
          <div
            class="cell-item"
            v-for="(item, index) in moreList"
            :key="item.id"
            @click="goTo(item.id)"
          >
            <div
              style="
                display: flex;
                align-items: center;
              "
            >
              <span class="function-icon" :class="item.tone" aria-hidden="true">
                {{ item.glyph }}
              </span>
              <div class="function-name">{{ $t("m.list2")[index] }}</div>
            </div>
            <div class="function-arrow">
              <span class="iconfont icon-jiantou_liebiaoxiangyou_o"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 70px"></div>
  </div>
</template>

<script>
import $store from "../../store";
import local from "@/utils/local";
import {
  getUser,
  getMenuUser,
  getMyUserInfo,
  getCustomerServiceLink
} from "@api/user";
import { isWeixin } from "@utils";
// import SwitchWindow from "@components/SwitchWindow";
// import GeneralWindow from "@components/GeneralWindow";
const NAME = "User";

export default {
  name: NAME,
  components: {
    // SwitchWindow,
    // GeneralWindow
  },
  props: {},
  data: function() {
    return {
      imgs1: [
        require("../../assets/images/yhk/vip0.png"),
        require("../../assets/images/yhk/vip1.png"),
        require("../../assets/images/yhk/vip2.png"),
        require("../../assets/images/yhk/vip3.png"),
        require("../../assets/images/yhk/vip4.png"),
        require("../../assets/images/yhk/vip5.png"),
        require("../../assets/images/yhk/vip6.png"),
        require("../../assets/images/yhk/vip7.png"),
        require("../../assets/images/yhk/vip8.png"),
        require("../../assets/images/yhk/vip9.png")
      ],
      userInfo: {},
      MyMenus: [],
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false,
      generalActive: false,
      timer: null,
      generalContent: {
        promoterNum: "",
        title: ""
      },
      funcList: {
        title: "",
        stimg: "/h5/img/yaoqing.04e5fd93.png",
        icon: require("@/assets/images/licai/yq1.png"),
        more: "更多服务",
        imgs: require("@/assets/images/yjt.png")
      },
      moreList1: [
        // {
        // 	id: 4,
        // 	text: '在线客服',

        // 	icon: require('@/assets/images/licai/di2.png'),
        // 	imgs: require('@/assets/images/yjt.png')
        // },
        {
          id: 44,
          text: "收益明细",
          icon: require("@/assets/images/img/wycz2.png"),
          imgs: require("@/assets/images/yjt.png")
        },
        // {
        //   id: 7,
        //   text: "我的资产",

        //   icon: require("@/assets/images/licai/di3.png"),
        //   imgs: require("@/assets/images/yjt.png")
        // },
        {
          id: 5,
          text: "我要充值",

          icon: require("@/assets/images/img/wycz1.png"),
          imgs: require("@/assets/images/yjt.png")
        },
        {
          id: 6,
          text: "我要提现",

          icon: require("@/assets/images/img/wytx2.png"),
          imgs: require("@/assets/images/yjt.png")
        }
      ],
      accountServices: [
        { title: "我的产品", desc: "返利与合同保障", path: "/myInvest", icon: "保", tone: "service-blue" },
        { title: "钱包地址", desc: "绑定与管理", path: "/bank", icon: "链", tone: "service-purple" },
        { title: "充值通道", desc: "账户入金", path: "/CzContent", icon: "充", tone: "service-green" },
        { title: "提现通道", desc: "资金转出", path: "/txCash", icon: "提", tone: "service-gold" },
        { title: "我的团队", desc: "成员与奖励", path: "/team", icon: "团", tone: "service-cyan" },
        { title: "会员等级", desc: "等级与权益", path: "/Grade", icon: "VIP", tone: "service-red" }
      ],
      moreList: [
        // {
        //   id: 2,
        //   icon: require("@/assets/images/licai/di1.png"),
        //   text: "安全保障",
        //   imgs: require("@/assets/images/yjt.png"),
        // },
        {
          id: 31,
          text: "提现记录",
          glyph: "提",
          tone: "function-blue",
          imgs: require("@/assets/images/yjt.png")
        },
        {
          id: 32,
          text: "充值记录",
          glyph: "充",
          tone: "function-green",
          imgs: require("@/assets/images/yjt.png")
        },
        {
          id: 33,
          text: "兑换记录",
          glyph: "兑",
          tone: "function-purple",
          imgs: require("@/assets/images/yjt.png")
        },
        {
          id: 133,
          text: "切换语言",
          glyph: "译",
          tone: "function-cyan",
          imgs: require("@/assets/images/yjt.png")
        },
        // {
        // 	id: 1001,
        // 	text: '虚拟币购买',
        // 	icon: require('@/assets/images/licai/di15.png'),
        // 	imgs: require('@/assets/images/yjt.png')
        // },
        {
          id: 10,
          text: "支付密码",
          glyph: "盾",
          tone: "function-gold",
          imgs: require("@/assets/images/yjt.png")
        },
        {
          id: 11,
          text: "登录密码",
          glyph: "钥",
          tone: "function-indigo",
          imgs: require("@/assets/images/yjt.png")
        },
        {
          id: 8,
          text: "退出登录",
          glyph: "退",
          tone: "function-red",
          imgs: require("@/assets/images/yjt.png")
        }
      ],
      conList: [
        {
          id: 0,
          img: require("@/assets/images/img/wycz2.png"),
          tit: "财务明细"
        },
        {
          id: 1,
          img: require("@/assets/images/img/cygn10.png"),
          tit: "我的团队"
        },
        {
          id: 2,
          img: require("@/assets/images/img/cygn11.png"),
          tit: "银行卡"
        },
        {
          id: 3,
          img: require("@/assets/images/img/cygn12.png"),
          tit: "实名认证"
        },
        {
          id: 4,
          img: require("@/assets/images/img/cygn13.png"),
          tit: "日利宝"
        },
        {
          id: 5,
          img: require("@/assets/images/img/cygn14.png"),
          tit: "我的投资"
        },
        {
          id: 6,
          img: require("@/assets/images/img/cygn15.png"),
          tit: "积分商城"
        },
        {
          id: 7,
          img: require("@/assets/images/img/cygn16.png"),
          tit: "邀请好友"
        }
      ],
      vipList: [
        require("@/assets/images/vip/vip0.png"),
        require("@/assets/images/vip/vip1.png"),
        require("@/assets/images/vip/vip2.png"),
        require("@/assets/images/vip/vip3.png"),
        require("@/assets/images/vip/vip4.png"),
        require("@/assets/images/vip/vip5.png"),
        require("@/assets/images/vip/vip6.png"),
        require("@/assets/images/vip/vip7.png"),
        require("@/assets/images/vip/vip8.png")
      ]
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User();
    }
  },
  computed: {
    userNickname() {
      const realname = String(this.userInfo.realname || "").trim();
      if (this.isAuthApproved && realname) {
        return realname;
      }
      return this.userInfo.nickname || "未设置昵称";
    },
    userAvatar() {
      return (
        this.userInfo.avatar_url ||
        this.userInfo.avatar ||
        require("@/assets/images/new/touxiang.png")
      );
    },
    userAccountName() {
      const account = String(
        this.userInfo.email ||
        this.userInfo.username ||
        this.userInfo.account ||
        this.userInfo.phone ||
        this.userInfo.mobile ||
        this.userInfo.uid ||
        "--"
      );
      const characters = Array.from(account);
      return characters.length > 4
        ? characters.slice(0, 4).join("") + "***"
        : account;
    },
    userVipName() {
      const level =
        this.userInfo.vip_level ||
        this.userInfo.vip ||
        this.userInfo.level ||
        0;
      return level > 0 ? `VIP${level}` : "普通会员";
    },
    isAuthApproved() {
      const hasAuthStatus =
        this.userInfo.auth_status !== null &&
        this.userInfo.auth_status !== undefined;
      if (hasAuthStatus) {
        return Number(this.userInfo.auth_status) === 1 && Number(this.userInfo.is_auth) === 1;
      }
      return Number(this.userInfo.is_auth) === 1;
    }
  },
  created() {
    let that = this;
    that.requ();
  },
  beforeDestroy() {
    console.log("销毁计时器");
    if (this.timer) {
      //如果定时器还在运行 或者直接关闭，不用判断
      clearInterval(this.timer); //关闭
    }
  },
  mounted: function() {
    this.isWeixin = isWeixin();
  },
  methods: {
    wayToLink(url) {
      this.$router.push({
        path: url
      });
    },
    qianBtn() {
      this.$router.push({
        path: "/Signln"
      });
    },
    requ() {
      getMyUserInfo().then(res => {
        this.userInfo = res.data.data;
      });
    },
    onWithdrawal() {
      this.$router.push({
        path: "/CzContent"
      });
    },
    onJF() {
      this.$router.push({
        path: "/member_transform"
      });
    },
    onRecharge() {
      this.$router.push({
        path: "/"
      });
    },
    shezhi() {
      this.$router.push({
        path: "/shezhi"
      });
    },
    openCustomerService() {
      getCustomerServiceLink({ _t: Date.now() })
        .then(res => {
          const kf = res && res.data ? res.data.data : "";
          this.openCustomerUrl(kf || $store.state.app.kf);
        })
        .catch(() => {
          this.openCustomerUrl($store.state.app.kf);
        });
    },
    openCustomerUrl(kf) {
      if (!kf) {
        return;
      }
      $store.commit("SET_KF", kf);
      console.log(kf);
      const plusRuntime = window.plus && window.plus.runtime;
      if (plusRuntime && plusRuntime.openURL) {
        plusRuntime.openURL(kf, function(res) {});
        return;
      }
      window.location.href = kf;
    },
    goTo: function(lists) {
      if (lists == 8) {
        this.$store.commit("LOGOUT");
        let usernames = window.localStorage.getItem("zhanghao");
        let quhao = window.localStorage.getItem("quhao");
        let passwords = window.localStorage.getItem("mima");
        let fwq = window.localStorage.getItem("fwq");
        let lang = window.localStorage.getItem("lang");
        local.clear();
        window.localStorage.setItem("zhanghao", usernames);
        window.localStorage.setItem("quhao", quhao);
        window.localStorage.setItem("mima", passwords);
        window.localStorage.setItem("fwq", fwq);
        window.localStorage.setItem("lang", lang);
        this.$router.push({
          path: `/login`
        });
        return;
      }
      switch (lists) {
        case 1:
          this.$router.push({ name: "article_detail", query: { id: 16 } });
          break;
        case 2:
          this.$router.push({ name: "article_detail", query: { id: 22 } });
          break;
        case 4:
          this.openCustomerService();
          break;
        case 5:
          this.onWithdrawal();
          break;
        case 6:
          this.$router.push({
            path: "/txCash"
          });
          break;
        case 7:
          this.$router.push({
            path: `/my-assets`,
            query: { tmoney: this.userInfo.tmoney }
          });
          break;
        case 10:
          this.$router.push({
            path: "/PayPass"
          });
          break;
        case 11:
          this.$router.push({
            path: "/LoginPass"
          });
          break;
        case 31:
          this.$router.push({
            path: "/withdrawal_record"
          });
          break;
        case 32:
          this.$router.push({
            path: "/deposit_record"
          });
          break;
        case 33:
          this.$router.push({
            path: "/dhlist"
          });
          break;
        case 111:
          this.$router.push({
            path: "/article"
          });
          break;
        case 133:
          this.$router.push({
            path: "/language"
          });

          break;
        case 1001:
          this.$router.push({
            path: "/xnblist"
          });

          break;
        case 44:
          this.$router.push({
            path: "/incomeDetail"
          });
          break;
        case 8:
          break;
        default:
          this.$router.push({
            path: "/"
          });
          break;
      }
    },
    dianji: function(id) {
      switch (id) {
        case 0:
          this.$router.push({
            path: "/moneyDetail"
          });
          break;
        case 1:
          this.$router.push({
            path: "/team"
          });
          break;
        case 7: //邀请好友
          this.$router.push({
            path: "/invitation"
          });
          break;
        case 3:
          this.$router.push({
            path: "/memmber_business"
          });
          break;
        case 4:
          this.$router.push({
            path: "/rilibaoindex"
          });
          break;
        case 6:
          this.$router.push({
            path: "/JfList"
          });
          break;
        case 5:
          this.$router.push({
            path: "/myInvest"
          });
          break;
        case 2:
          this.$router.push({
            path: "/bank"
          });
          break;
        default:
          this.$router.push({
            path: "/"
          });
          break;
      }
    },
    // 安全保障
    anquan: function() {
      this.$router.push({
        path: "/anquan"
      });
    },
    // 新手帮助
    news: function() {
      this.$router.push({
        path: "/news"
      });
    },
    changeswitch: function(data) {
      this.switchActive = data;
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
        that.orderStatusNum = res.data.orderStatusNum;
      });
    },
    MenuUser: function() {
      let that = this;
      getMenuUser().then(res => {
        that.MyMenus = res.data.routine_my_menus;
      });
    },
    goPagey(url) {
      this.$router.push({
        path: url
      });
    },
    goPages: function(index) {
      let url = this.MyMenus[index].wap_url;
      // 卡密激活
      if (url == "/user/user_coupon") {
        this.$router.push({
          path: "/user/get_coupon"
        });
        return;
      }
      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({
          mes: "您还不是客服！！"
        });
      }
      this.$router.push({
        path: this.MyMenus[index].wap_url
      });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
    },
    wayUserMobileShow(val) {
      if (!val) {
        return "";
      }
      return val.slice(0, 2) + " " + val.slice(-11);
    },
    formatMoney(value) {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return value || "0.00";
      }
      return num.toFixed(2);
    }
  }
};
</script>

<style scoped lang="less">
.contents {
  background-image: url(../../assets/images/user_bank.png);
  background-repeat: no-repeat;
  background-size: 100% 380px;
}

.account-hub {
  margin-top: 13px;
  padding: 16px 13px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 9px 24px rgba(27, 55, 91, 0.06);
}

.user-account-name {
  margin-top: 4px;
  color: #8a95a4;
  font-size: 10px;
}

.account-hub-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.account-hub-title small {
  display: block;
  color: #7797bd;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 1px;
}

.account-hub-title h3 {
  margin-top: 4px;
  color: #26364d;
  font-size: 16px;
}

.account-hub-title button {
  color: #78869a;
  font-size: 9px;
  border: 0;
  background: none;
}

.account-service-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 9px;
}

.account-service-grid button {
  padding: 12px 3px 10px;
  text-align: center;
  border: 0;
  background: #f8fafc;
  border-radius: 12px;
}

.account-service-grid button > span {
  display: grid;
  width: 35px;
  height: 35px;
  margin: 0 auto 7px;
  place-items: center;
  font-size: 10px;
  font-weight: 700;
  border-radius: 11px;
}

.account-service-grid strong,
.account-service-grid small {
  display: block;
}

.account-service-grid strong {
  color: #3a485c;
  font-size: 10px;
}

.account-service-grid small {
  margin-top: 4px;
  color: #9aa3af;
  font-size: 7px;
}

.service-blue { color: #2d70c7; background: #eaf3ff; }
.service-purple { color: #7555bf; background: #f0ebff; }
.service-green { color: #218869; background: #e7f8f1; }
.service-gold { color: #aa7425; background: #fff3de; }
.service-cyan { color: #198695; background: #e5f7f9; }
.service-red { color: #b85d4e; background: #fff0ec; }

.user {
  font-size: 14px;
  background-color: #fff;
  background-image: url(../../assets/images/bg233.png);
  background-repeat: no-repeat;
  background-size: 100% 200px;
}

.user_con_select {
  padding: 10px 0;

  margin-top: 8px;
  background-color: #ffffff;
}

.user_con_select_tit {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
  padding: 8px 15px;
}

.user_con_select_list {
  display: flex;
  align-items: center;
  padding: 15px 15px;
  /* border-bottom: 1px solid #eee; */
}

.user_con_select_list img {
  margin-left: auto;
  width: 16px;
}

.user_con_select_list p {
  font-size: 14px;
  color: #000000;
}

.user_con_mid {
  margin-top: 12px;
  overflow: hidden;
  background:
    radial-gradient(circle at 100% 0, rgba(73, 139, 222, 0.08), transparent 34%),
    linear-gradient(145deg, #ffffff 0%, #fbfcff 100%);
  padding: 14px 0 8px;
  border: 1px solid rgba(67, 105, 157, 0.08);
  box-shadow: 0 8px 24px rgba(33, 67, 109, 0.055);
}

.user_con_mid_tit {
  position: relative;
  color: #26364d;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 8px;
  padding: 0 16px 0 25px;
  letter-spacing: 0.2px;
}

.user_con_mid_tit::before {
  content: "";
  position: absolute;
  left: 15px;
  top: 5px;
  width: 3px;
  height: 11px;
  background: linear-gradient(#5aa7ff, #2474d5);
  border-radius: 3px;
}

.user_con_mid_block {
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  align-items: baseline;
  margin-top: 10px;
}

.home_tit {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  background-repeat: no-repeat;
  background-size: 100%;
  width: 100%;
}

.home_tit_top {
  height: 50px;

  display: flex;
  align-items: center;
}

.home_swiper {
  width: 100%;
  height: 190px;
}

.home_swiper swiper-slide {
  width: 100%;
  height: 190px;
}

.home_swiper {
  height: 190px;
}

.banner_img {
  width: 100%;
  height: 190px;
}

.home_tit_left {
  width: 25%;
  display: flex;
  align-items: center;
}

.home_tit_left img {
  width: 23px;
  height: 23px;
}

.home_tit_left div {
  margin: 0 20px;
  color: #333;
  font-size: 16px;
}

.home_tit_middle {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  margin: 0 0px;
  color: #333;
  font-weight: bold;
  font-size: 22px;
}

.home_tit_middle img {
  width: 15px;
  height: 15px;
  margin-left: 7px;
}

.home_tit_right {
  padding-right: 10px;
  width: 50%;
  display: flex;
  align-items: center;
  color: #333;
  flex-direction: row-reverse;

  font-size: 15px;
  font-weight: bold;
}

.home_tit_right img {
  width: 22px;
  height: 22px;
  margin-left: 7px;
}

.yaoqing {
  width: 100%;
}

.user_con_mid_line {
  width: 25%;
  margin-bottom: 12px;
}

.user_con_mid_line img {
  width: 33px;
  display: block;
  margin: 0 auto;
}

.user_con_mid_line p {
  text-align: center;
  margin-top: 8px;
  font-size: 13px;
}

/* .user_con_top_but button{margin-left: 15px;} */
.user_con_top {
  border-radius: 6px;
  padding: 0px 0px;
  /* display: flex;
        align-items: center;
        justify-content: space-around; */
}

.user_con_top_but {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px !important;
}

.user_con_top_but button:first-child {
  width: 43px;
  height: 20px;
  background: #ffffff;
  border: 1px solid #cf4948;
  margin-right: 14px;
  border-radius: 10px;
  color: #cf4948;
  line-height: 18px;
  text-align: center;
}

.user_con_top_but button:last-child {
  width: 43px;
  height: 20px;
  background: #ffffff;
  border: 1px solid #1664fc;
  border-radius: 10px;
  color: #1664fc;
  text-align: center;
  line-height: 18px;
}

.user_con {
  width: 100%;
  /* background-color: #f2f1f6; */
  padding: 0px 0px;
  position: relative;
  /* padding-bottom: 70px !important; */
  top: -20px;
}

.footer-line-height {
  height: 1rem;
}

.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #334eec;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 14px;
  padding: 0 0.08rem;
  border: 1px solid #334eec;
}

.pictrue {
  position: relative;
}

.switch-h5 {
  margin-left: 0.2rem;
}

.binding {
  padding: 0.05rem 0.2rem;
  background-color: #4aa8fa;
  border-radius: 50px;
  font-size: 14px;
  border: 1px solid #4aa8fa;
  color: #ffffff;
  width: 50%;
  text-align: center;
  margin-top: 10px;
}
.userBox {
  background-color: #fff;
  padding: 10px;
  border-radius: 14px;
  margin-top: 35px;
}
.cell {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  .cell-item {
    position: relative;
    min-height: 48px;
    padding: 7px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #344257;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  .cell-item:not(:last-child)::after {
    content: "";
    position: absolute;
    left: 55px;
    right: 15px;
    bottom: 0;
    height: 1px;
    background: #edf1f6;
    transform: scaleY(0.5);
  }

  .cell-item:active {
    background: #f3f7fc;
  }
}

.function-icon {
  display: grid;
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  place-items: center;
  font-size: 11px;
  font-weight: 700;
  border-radius: 9px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.72);
}

.function-name {
  margin-left: 11px;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
}

.function-arrow {
  display: grid;
  width: 24px;
  height: 24px;
  color: #b8c1ce;
  place-items: center;
  font-size: 12px;
}

.function-blue { color: #2a72c9; background: #e9f3ff; }
.function-green { color: #21876b; background: #e8f8f1; }
.function-purple { color: #7657bc; background: #f0ebff; }
.function-cyan { color: #197f94; background: #e5f7fa; }
.function-gold { color: #a87220; background: #fff3dc; }
.function-indigo { color: #5367b5; background: #edf0ff; }
.function-red { color: #b75b58; background: #fff0ef; }

@media (min-width: 768px) {
  .user_con_mid_tit {
    font-size: 13px;
  }

  .cell .cell-item {
    min-height: 44px;
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .function-icon {
    width: 28px;
    height: 28px;
    flex-basis: 28px;
    font-size: 10px;
    border-radius: 8px;
  }

  .function-name {
    font-size: 12px;
  }
}
.row-middle {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.balance-card {
  min-height: 128px;
  margin-top: 10px;
  padding: 14px 16px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  background: linear-gradient(135deg, #2f8df4 0%, #167bf2 52%, #21a3ff 100%);
  box-shadow: 0 10px 22px rgba(25, 126, 243, 0.18);
}
.balance-copy {
  min-width: 0;
  flex: 1;
}
.balance-label {
  margin: 0 0 8px;
  font-size: 14px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
}
.balance-value {
  margin: 0;
  min-width: 0;
  display: flex;
  align-items: baseline;
}
.balance-value span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 24px;
  line-height: 30px;
  font-weight: 900;
}
.balance-value em {
  margin-left: 8px;
  font-size: 14px;
  line-height: 18px;
  font-style: normal;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.9);
}
.balance-breakdown {
  display: flex;
  gap: 20px;
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.24);
}
.balance-breakdown p {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.balance-breakdown span {
  color: rgba(255, 255, 255, 0.78);
  font-size: 12px;
}
.balance-breakdown strong {
  color: #fff;
  font-size: 14px;
  font-weight: 800;
}
.balance-icon {
  width: 42px;
  height: 42px;
  flex: 0 0 auto;
  margin-left: 12px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.16);
}
.balance-icon img {
  width: 32px;
  height: 32px;
  display: block;
}
</style>

